import { Empty } from 'antd'
import React from 'react'

const KanbanInwardPage = () => {
  return (
    <Empty />
  )
}

export default KanbanInwardPage